/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React from "react";
import { cn } from "tailwind-variants";
import { useI18n } from "intl/useI18n";
import { useDtfStore } from "../store";
import "./MultiSizeTotalSummary.scss";
import { renderList } from "common/vue/render-list";

export default function MultiSizeTotalSummary({ index, ...restProps }: any) {
  const store = useDtfStore();
  const { t, n } = useI18n();

  function artworks() {
    // @ts-expect-error TS(4111): Property 'artworks' comes from an index signature,... Remove this comment to see the full error message
    return store.artworks;
  }

  function summary() {
    // @ts-expect-error TS(4111): Property 'summary' comes from an index signature, ... Remove this comment to see the full error message
    return store.summary;
  }

  function simulation() {
    // @ts-expect-error TS(4111): Property 'simulation' comes from an index signatur... Remove this comment to see the full error message
    return store.simulation;
  }

  function isPricingLoading() {
    // @ts-expect-error TS(4111): Property 'isPricingLoading' comes from an index si... Remove this comment to see the full error message
    return store.isPricingLoading;
  }

  function artwork() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return artworks()[index];
  }

  function isArtworkUploaded() {
    const artworkId = parseInt(artwork()?.id.toString() ?? "", 10);
    if (Number.isNaN(artworkId)) {
      return false;
    }
    return typeof artworkId === "number" && !artwork()?.isLoading;
  }

  function showPricing() {
    return index === 0 || isArtworkUploaded();
  }

  function sizesAndQuantities() {
    return artwork()?.sizesAndQuantities ?? [];
  }

  function sizesCount() {
    return sizesAndQuantities().length;
  }

  function quantity() {
    return sizesAndQuantities().reduce((acc: any, curr: any) => acc + Number(curr.quantity), 0);
  }

  function pricing() {
    if (artwork()?.isFile || !sizesAndQuantities().some((sq: any) => Number(sq.quantity) > 0)) {
      return simulation();
    }
    return sizesAndQuantities() || simulation();
  }

  function enableAbAiMonetization() {
    // @ts-expect-error TS(4111): Property 'enableAbAiMonetization' comes from an in... Remove this comment to see the full error message
    return store.enableAbAiMonetization;
  }

  function getBogoAdjustedPrice() {
    // @ts-expect-error TS(4111): Property 'getBogoAdjustedPrice' comes from an inde... Remove this comment to see the full error message
    return store.getBogoAdjustedPrice;
  }

  function isBogoApplicable() {
    // @ts-expect-error TS(4111): Property 'isBogoApplicable' comes from an index si... Remove this comment to see the full error message
    return store.isBogoApplicable;
  }

  function getPrice(propertyName: any) {
    if (Array.isArray(pricing())) {
      const artworkId = String(artwork()?.id ?? "");
      return pricing()
        .reduce((sum: any, item: any) => {
          // Check for BOGO-adjusted price for unit price
          if (propertyName === "unitPrice" && artworkId) {
            const sizeKey = `${item.width}x${item.height}`;
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            const bogoPrice = getBogoAdjustedPrice()(artworkId, item.id, sizeKey);
            if (bogoPrice) {
              return sum + bogoPrice.discountedTotalPrice;
            }
          }
          const price = Number(item[propertyName] || 0);
          return sum + price * item.quantity;
        }, 0)
        .toFixed(2);
    }
    const price = pricing()[propertyName];
    if (!price) {
      return null;
    }
    return Number(Number(price).toFixed(2)) * pricing().quantity;
  }

  function originalTotal() {
    if (!Array.isArray(pricing())) {
      const price = pricing()?.unitPrice;
      const qty = pricing()?.quantity ?? 0;
      if (!price || qty === 0) return null;
      return Number(Number(price).toFixed(2)) * qty;
    }
    return pricing()
      .reduce((sum: any, item: any) => {
        const price = Number(item.unitPrice || 0);
        return sum + price * item.quantity;
      }, 0)
      .toFixed(2);
  }

  function bogoInfo() {
    if (!isBogoApplicable() || !Array.isArray(pricing())) {
      return {
        freeQty: 0,
        discount: 0
      };
    }
    const artworkId = String(artwork()?.id ?? "");
    let freeQty = 0;
    let discountAmount = 0;
    pricing().forEach((item: any) => {
      const sizeKey = `${item.width}x${item.height}`;
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const bogoPrice = getBogoAdjustedPrice()(artworkId, item.id, sizeKey);
      if (bogoPrice && bogoPrice.freeQty > 0) {
        freeQty += bogoPrice.freeQty;
        const itemOriginalTotal = Number(item.unitPrice || 0) * item.quantity;
        discountAmount += itemOriginalTotal - bogoPrice.discountedTotalPrice;
      }
    });
    return {
      freeQty,
      discount: discountAmount
    };
  }

  function retailTotal() {
    return getPrice("retailPrice");
  }

  function total() {
    return getPrice("unitPrice");
  }

  function discount() {
    const retail = parseFloat(retailTotal()?.toString() ?? "");
    const actual = parseFloat(total()?.toString() ?? "");
    if (!retail || !actual) return 0;
    return Number(Math.ceil(((retail - actual) / retail) * 100).toFixed(0));
  }

  function enhancements() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    if (!summary().enhancements) {
      return [];
    }
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return Object.values(summary().enhancements);
  }

  function orderSubtotal() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return Number(summary().orderSubtotal);
  }

  function artworksReady() {
    return artwork()?.isSimulated || (!artwork()?.isLoading && artwork()?.enhancementCompleted);
  }

  return (
    <>
      {pricing() ? (
        <div
          {...restProps}
          className={cn("multi-size-total-summary scope-3cac75a9", restProps?.className, {
            "multi-size-total-summary--loading":
              !enableAbAiMonetization() && (isPricingLoading() || total() === 0)
          })}
        >
          <h3 className="multi-size-total-summary__caption scope-3cac75a9">Total</h3>
          {enableAbAiMonetization() && (isPricingLoading() || !artworksReady() || total() === 0) ? (
            <div className="multi-size-total-summary__skeleton scope-3cac75a9">
              <div className="multi-size-total-summary__skeleton-block scope-3cac75a9" />
              <div className="multi-size-total-summary__skeleton-block scope-3cac75a9" />
              <div className="multi-size-total-summary__skeleton-block scope-3cac75a9" />
            </div>
          ) : (
            <div className="multi-size-total-summary__grid scope-3cac75a9">
              {sizesCount() > 0 ? (
                <>
                  <div className="multi-size-total-summary__item scope-3cac75a9">
                    <span className="multi-size-total-summary__label scope-3cac75a9">
                      <span className="multi-size-total-summary__info scope-3cac75a9">for</span>{" "}
                      {t("transfer", quantity())}
                    </span>
                  </div>
                  {showPricing() ? (
                    <div className="multi-size-total-summary__item scope-3cac75a9">
                      <span className="multi-size-total-summary__price scope-3cac75a9">
                        {n(bogoInfo().freeQty > 0 ? originalTotal() : total(), "currency")}
                      </span>
                      {retailTotal() && discount() > 0 && bogoInfo().freeQty === 0 ? (
                        <span className="multi-size-total-summary__old-price scope-3cac75a9">
                          {n(retailTotal(), "currency")}
                        </span>
                      ) : null}
                      {discount() > 0 && bogoInfo().freeQty === 0 ? (
                        <span className="multi-size-total-summary__discount scope-3cac75a9">
                          {discount()}% off{" "}
                        </span>
                      ) : null}
                    </div>
                  ) : null}
                  {bogoInfo().freeQty > 0 ? (
                    <>
                      <div className="multi-size-total-summary__item scope-3cac75a9">
                        <span className="multi-size-total-summary__label multi-size-total-summary__label--bogo scope-3cac75a9">
                          {bogoInfo().freeQty} FREE{" "}
                          {bogoInfo().freeQty === 1 ? "Transfer" : "Transfers"}
                        </span>
                      </div>
                      <div className="multi-size-total-summary__item scope-3cac75a9 -ml-[6.5px]">
                        <span className="multi-size-total-summary__price multi-size-total-summary__price--bogo scope-3cac75a9">
                          {" "}
                          -{n(bogoInfo().discount, "currency")}
                        </span>
                      </div>
                    </>
                  ) : null}
                </>
              ) : null}
              {renderList(enhancements(), enhancement => (
                <>
                  {Number(enhancement.totalPrice) > 0 ? (
                    <>
                      <div className="multi-size-total-summary__item scope-3cac75a9">
                        <span className="multi-size-total-summary__label scope-3cac75a9">
                          <span className="multi-size-total-summary__info scope-3cac75a9">for</span>{" "}
                          {enhancement.quantity} {enhancement.serviceName}
                        </span>
                      </div>
                      <div className="multi-size-total-summary__item scope-3cac75a9">
                        <span className="multi-size-total-summary__price scope-3cac75a9">
                          {n(enhancement.totalPrice, "currency")}
                        </span>
                      </div>
                    </>
                  ) : null}
                </>
              ))}
              {orderSubtotal() || bogoInfo().freeQty > 0 ? (
                <>
                  <div className="multi-size-total-summary__item scope-3cac75a9">
                    <span className="multi-size-total-summary__label scope-3cac75a9">Subtotal</span>
                  </div>
                  <div className="multi-size-total-summary__item scope-3cac75a9">
                    <span className="multi-size-total-summary__price scope-3cac75a9">
                      {n(bogoInfo().freeQty > 0 ? total() : orderSubtotal(), "currency")}
                    </span>
                    {bogoInfo().discount > 0 ? (
                      <span className="multi-size-total-summary__savings scope-3cac75a9">
                        {" "}
                        You save {n(bogoInfo().discount, "currency")}!{" "}
                      </span>
                    ) : null}
                  </div>
                </>
              ) : null}
            </div>
          )}
        </div>
      ) : null}
    </>
  );
}
